import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { brandColors } from '../../constants/brandColors';

/**
 * WaSwitch — toggle custom no estilo do design system da designer (42×24, verde WhatsApp).
 * Substitui o MUI Switch na /integrations (G7) para bater pixel a pixel com o mockup.
 */
export default function WaSwitch({ checked, onChange, disabled = false, ariaLabel }) {
  const toggle = () => { if (!disabled) onChange(!checked); };
  return (
    <Box
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      tabIndex={disabled ? -1 : 0}
      onClick={toggle}
      onKeyDown={(e) => {
        if (!disabled && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); toggle(); }
      }}
      sx={{
        width: 42,
        height: 24,
        flexShrink: 0,
        borderRadius: 999,
        bgcolor: checked ? brandColors.whatsapp.main : '#c2cad1',
        position: 'relative',
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.55 : 1,
        transition: 'background-color .15s',
        outline: 'none',
        '&:focus-visible': { boxShadow: '0 0 0 3px rgba(37,211,102,.35)' },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '2px',
          left: checked ? '20px' : '2px',
          width: 20,
          height: 20,
          borderRadius: '50%',
          bgcolor: '#fff',
          boxShadow: '0 1px 3px rgba(0,0,0,.3)',
          transition: 'left .15s',
        }}
      />
    </Box>
  );
}

WaSwitch.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
};
